import React from "react";

const Switch = ({ field, form, id, label, className, ...props }) => {
    const handleChange = () => {
        form.setFieldValue(field.name, !field.value);
    };

    return (
        <div className={`flex items-center gap-2 ${className}`}>
            {label && (
                <label htmlFor={id} className="block text-start">
                    {label}
                </label>
            )}
            <label htmlFor={id} className="flex items-center cursor-pointer">
                <div className="relative">
                    <input
                        id={id}
                        type="checkbox"
                        {...field}
                        {...props}
                        checked={field.value}
                        onChange={handleChange}
                        className="sr-only"
                    />
                    <div
                        className={`block w-12 h-6 rounded-full ${field.value ? "bg-blue-700" : "bg-gray-300"
                            }`}
                    ></div>
                    <div
                        className={`absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform ${field.value ? "transform translate-x-6" : ""
                            }`}
                    ></div>
                </div>
            </label>
        </div>
    );
};

export default Switch;
